import fetch from '@/plugin/axios'

// 属性列表
export function attList (query, type) {
  return fetch({
    url: `/api/member/user-attribute/list/${type}`,
    method: 'Post',
    data: query
  })
}

// 添加属性
export function addAtt (query) {
  return fetch({
    url: '/api/member/user-attribute/add',
    method: 'Post',
    data: query
  })
}

// 删除属性
export function delAtt (id) {
  return fetch({
    url: `/api/member/user-attribute/remove/${id}`,
    method: 'Get'
  })
}

// 修改属性
export function editAtt (query, id) {
  return fetch({
    url: `/api/member/user-attribute/update/${id}`,
    method: 'Post',
    data: query
  })
}

// 属性信息
export function attDetailInfo (id) {
  return fetch({
    url: `/api/member/user-attribute/info/${id}`,
    method: 'Get'
  })
}
